// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__qbz0B","avatarMedium":"Avatar_avatarMedium__IBMWM","avatarBig":"Avatar_avatarBig__8vSFY","avatarImage":"Avatar_avatarImage__XQY3p"};